export const BRAND_NAME = "DoExim";
export const BRAND_SITE_URL = "https://doexim.com";
export const BRAND_ASSET_VERSION = "2026-05-06";
export const BRAND_LOGO_SRC = `/logo.png?v=${BRAND_ASSET_VERSION}`;
export const BRAND_LOGO_DARK_SRC = `/logoDark.png?v=${BRAND_ASSET_VERSION}`;
export const BRAND_FAVICON_SRC = `/favicon.png?v=${BRAND_ASSET_VERSION}`;
export const BRAND_LOGO_ALT = `${BRAND_NAME} logo`;
